import { post, get } from '../utils/apiUtils';

// Search audit logs from backend
// Payload shape:
// {
//   min_level: 'INFO' | 'DEBUG' | 'WARNING' | 'ERROR',
//   modules: string[],
//   functions: string[],
//   logger_names: string[],
//   since_hours: number | null,
//   from_date: string | null,
//   to_date: string | null,
//   page: number,
//   page_size: number
// }
export async function searchAuditLogs(payload) {
  return post('/api/v1/mms_ai_audit_logging/audit/log/screen/search', payload, {
    _skipDeduplication: true,
  });
}

// Fetch latest run details by run/trace id
export async function fetchLatestRunByTraceId(traceId) {
  const safeId = encodeURIComponent(traceId);
  return get(`/api/v1/mms_ai_metric_events/metrics/runs/latest_run_by_run_id/${safeId}`, {
    _skipDeduplication: true,
  });
}

export default { searchAuditLogs };
